import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeletionDialogComponent } from 'src/app/layout/deletion-dialog/deletion-dialog.component';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { AirlineSettingsDialogComponent } from './airline-settings-dialog/airline-settings-dialog.component';
import { AirlineSettingsService } from './airline-settings.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Airline } from 'src/app/shared/shared.models';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatChip } from '@angular/material/chips';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-airline-settings',
    templateUrl: './airline-settings.component.html',
    styleUrls: ['./airline-settings.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    imports: [MatDivider, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatChip, NgClass, MatIconButton, RouterLink, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class AirlineSettingsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  parent: any;
  data: any;

  displayedColumns: string[] = [
    'id',
    'airlineName',
    'abbreviation',
    'iata',
    'status',
    'actions',
  ];
  tabledata: Airline[] = [];
  dataSource = new MatTableDataSource();
  airline: Airline;

  airlineDetail: Airline;
  dialogConfig = new MatDialogConfig();

  searchForm: UntypedFormGroup;

  constructor(
    private snackbarService: SnackbarService,
    private airlineSettingsService: AirlineSettingsService,
    private dialog: MatDialog,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.fetchData();
    this.searchForm = new UntypedFormGroup({
      filter: new UntypedFormControl(''),
    });
  }

  openAdd(): void {
    const dialogRef = this.dialog.open(AirlineSettingsDialogComponent, {
      width: '700px',
    });
    dialogRef.afterClosed().subscribe((data: Airline) => {
      if (data) {
        this.submit(data);
      }
    });
  }

  openEdit(data: any, rowIndex?: number): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.width = '700px';

    const dialogRef = this.dialog.open(
      AirlineSettingsDialogComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((data: Airline) => {
      if (data) {
        this.submit(data);
      } else {
        this.fetchData();
      }
    });
  }

  refreshTable(tabledata: Airline[]): void {
    this.dataSource = new MatTableDataSource(tabledata);
    this.dataSource.paginator = this.paginator;
  }

  fetchData(): void {
    this.spinnerService.startSpinner();
    this.airlineSettingsService.fetchAirlines().subscribe(
      (data: Airline[]) => {
        this.tabledata = data;

        this.dataSource = new MatTableDataSource(this.tabledata);
        this.dataSource.paginator = this.paginator;
        this.spinnerService.stopSpinner();
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }


  deleteColumn(airline: Airline, index: number): void {
    const dialogRef = this.dialog.open(
      DeletionDialogComponent,
      this.dialogConfig
    );

    dialogRef.afterClosed().subscribe((data) => {
      this.spinnerService.startSpinner();
      if (data) {
        this.airlineSettingsService.deleteAirline(airline.id).subscribe(
          () => {
            this.fetchData();
            this.snackbarService.openSuccess();

          },
          (error: any) => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openError(error.status);
          }
        );
      }
    });
  }

  submit(airline: Airline): void {
    this.spinnerService.startSpinner();
    // wenn id vorhanden: update
    if (airline.id) {
      this.airlineSettingsService.putAirline(airline).subscribe(
        (data: Airline) => {
          for (let i = 0; i < this.tabledata.length; i++) {
            if (this.tabledata[i].id === data.id) {
              this.tabledata[i] = data;
              this.spinnerService.stopSpinner();
              this.snackbarService.openSuccess();
            }
          }

          this.refreshTable(this.tabledata);
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    } else {
      // wenn keine id vorhanden: create
      this.airlineSettingsService.postAirline(airline).subscribe(
        (data: Airline) => {
          this.tabledata.push(data);
          this.refreshTable(this.tabledata);
          this.spinnerService.stopSpinner();
          this.snackbarService.openSuccess();
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    }
  }

  // -- search --

  clearSearch(): void {
    this.searchForm.controls['filter'].setValue('');
    this.applyFilter();
  }

  applyFilter(): void {
    const filterValue = this.searchForm.value.filter;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
